import { TFunction } from 'i18next';
import { Documentation } from 'graphql-common';
import { NavItem } from '@lib/components/Menu/Menu';
import getTableActionsMenu from '../../../DocumentList/utils/getTableActionsMenu';
import { AnalyticsDocumentRow } from './getTopDocumentsTableColumns';

interface Args {
  onViewDocument: (item: Documentation) => void;
  onVersionNotes: (item: Documentation) => void;
  onDetails: (item: Documentation) => void;
  onEdit: (item: Documentation) => void;
  onDelete: (item: Documentation) => void;
  t: TFunction<'translation', undefined>;
}

/**
 * Wraps the shared document list action menu, adapting each entry from
 * `Documentation`-based callbacks to `AnalyticsDocumentRow`-based callbacks
 * (the table row carries an analytics aggregate plus a nested `documentation`
 * reference that the menu items operate on).
 */
export default function getTopDocumentsActionsMenu({
  onViewDocument,
  onVersionNotes,
  onDetails,
  onEdit,
  onDelete,
  t,
}: Args): NavItem<AnalyticsDocumentRow>[] {
  const menu = getTableActionsMenu({
    onViewDocument,
    onVersionNotes,
    onDetails,
    onEdit,
    onDelete,
    t,
  });

  return menu.map((navItem): NavItem<AnalyticsDocumentRow> => {
    const inner = navItem.onClick;
    const innerDisable = navItem.predictorFnDisable;
    const next: NavItem<AnalyticsDocumentRow> = {
      id: navItem.id,
      title: navItem.title,
      type: navItem.type,
      leftIcon: navItem.leftIcon,
      onClick: (row?: AnalyticsDocumentRow) => {
        if (row?.documentation && inner) inner(row.documentation);
      },
    };
    if (innerDisable) {
      next.predictorFnDisable = (row?: AnalyticsDocumentRow) =>
        !!innerDisable(row?.documentation);
    }
    return next;
  });
}
